<template>
<div class="container">
  <div v-if="showIntro" class="section has-text-centered">
    <span class="intro-time">
      Get Ready! <br/>
      {{introTime}}
    </span>
  </div>
  <div v-else class="section">
    <div class="level is-mobile">
      <div class="level-left">
        <div class="level-item">
          <h2 class="title is-4 has-text-centered has-text-grey">
            Question {{currentIndex}}/{{questions.length}}
          </h2>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <span class="time-keeper">
            <span>
              {{remainingTime}}
            </span>
            <span class="icon">
              <i class="fas fa-stopwatch"></i>
            </span>
          </span>
        </div>
      </div>
    </div>
    <h1 class="title is-1 has-text-centered has-text-weight-bold">
      {{question.data.question}}
    </h1>
    <div class="section">
      <question-result v-if="isAnswered" :question="question" />
      <question-choices v-else :question="question" />
    </div>
  </div>
</div>
</template>

<script>
import QuestionChoices from './ub-question-choices.vue';
import QuestionResult from './ub-question-result.vue';

const DEADLINE = 10;
const INTRO_TIME = 3;

export default {
  name: 'ub-question',
  props: [],
  timers: {
    countdown: {
      time: 1000,
      repeat: true,
    },
    intro: {
      time: 1000,
      repeat: true,
    },
    goNext: {
      time: 3000,
    }
  },
  data() {
    return {
      isBusy: false,
      currentQuestionIndex: 0,
      remainingTime: DEADLINE,
      showIntro: false,
      introTime: INTRO_TIME,
      forcedNav: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters['user/dbUser'];
    },
    currentIndex() {
      return this.currentQuestionIndex + 1;
    },
    trivia() {
      return this.$store.getters['trivia/trivia'];
    },
    questions() {
      return this.$store.getters['trivia/questions'];
    },
    question() {
      return this.questions[this.currentQuestionIndex];
    },
    choices() {
      return this.question.data.choices;
    },
    isAnswered() {
      const { answers } = this.question.data;
      if (answers && answers.length) {
        const foundIndex = answers.findIndex(a => a.userId === this.user.id);
        if (foundIndex > -1) return true;
      }
      return false;
    },
    players() {
      return this.$store.getters['trivia/players'];
    },
    iAmPlayer() {
      return this.players.findIndex(p => p.id === this.user.id) !== -1;
    },
  },
  methods: {
    countdown() {
      this.remainingTime -= 1;
      if (this.remainingTime === 0) {
        this.$timer.stop('countdown');
        //* go to next question
        this.handleTimeout();
      }
    },
    handleTimeout() {
      console.log('handle timeout');
      console.log(this.isAnswered);
      //* if not answered yet, add a blank answer.
      if (!this.isAnswered) {
        this.addBlank().then(() => {
          //* show results for a while.
          //* then lets move on.
          this.$timer.stop('goNext');
          this.$timer.start('goNext');
        });
      } else {
        this.$timer.stop('goNext');
        this.$timer.start('goNext');
      }
    },
    startIntro() {
      this.showIntro = true;
      //* go to next question in 3 seconds
      this.$timer.start('intro');
    },
    intro() {
      this.introTime -= 1;
      if (this.introTime === 0) {
        this.$timer.stop('intro');
        this.showIntro = false;
        this.introTime = INTRO_TIME;
        this.currentQuestionIndex += 1;
        this.remainingTime = DEADLINE;
        this.$timer.start('countdown');
      }
    },
    goNext() {
      console.log(this.questions.length - 1);
      if (this.currentQuestionIndex < this.questions.length - 1) {
        // go to next question
        this.startIntro();
      } else {
        // finish the game.
        this.finishGame();
      }
    },
    finishGame() {
      if (this.isBusy) return;
      this.isBusy = true;
      this.$store.dispatch('trivia/endGame', {
        game: this.trivia,
      }).then(() => {
        this.isBusy = false;
        this.forcedNav = true;
        this.gotoResult();
      }).catch((err) => {
        this.isBusy = false;
        console.error(err);
        throw err;
      });
    },
    gotoResult() {
      this.$router.replace({
        name: 'ub-result'
      });
    },
    initialize() {
      if (this.trivia.data.status === 'complete') {
        this.$router.push({
          name: 'ub-result'
        });
        return;
      }
      //* start the timer
      this.$timer.start('countdown');
    },
    addBlank() {
      if (this.isBusy) return;
      this.isBusy = true;
      return this.$store.dispatch('trivia/answerQuestion', {
        question: this.question,
        user: this.user,
        choice: null,
      }).then(() => {
        this.isBusy = false;
      }).catch((err) => {
        this.isBusy = false;
        console.error(err);
        throw err;
      });
    },
    registerGuard() {
      window.addEventListener('beforeunload', this.handleUnload);
    },
    handleUnload(event) {
      event.preventDefault();
      event.returnValue = "";
    },
    leaveGame(next) {
      if (this.isBusy) return;
      this.isBusy = true;
      this.$store.dispatch('trivia/removePlayer', {
        gameId: this.trivia.id,
        player: this.user,
      }).then(() => {
        this.isBusy = false;
        this.$buefy.toast.open({
          type: 'is-success',
          message: 'Exited game',
        });
        next();
      }).catch((err) => {
        this.isBusy = false;
        console.error(err);
        throw err;
      });
    },
  },
  mounted() {
    //* if i'm not one of the players, throw out to home
    if (!this.iAmPlayer) {
      this.forcedNav = true;
      this.$router.push({
        name: 'ub-home',
      });
      return;
    }
    this.initialize();
    this.registerGuard();
  },
  beforeRouteLeave (to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    console.log(this.forcedNav);
    if (this.forcedNav) {
      next();
      return;
    }
    if (this.trivia.data.status !== 'completed') {
      //* if we're leaving before the game has completed
      this.$buefy.modal.open({
        props: {
          next: next,
        },
        events: {
          confirmed: this.leaveGame,
        },
        parent: this,
        canCancel: false,
        component: () => import('../ub-confirm-leave.modal.vue'),
        hasModalCard: true,
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleUnload);
  },
  components: {
    QuestionChoices,
    QuestionResult,
  },
};
</script>

<style lang="scss" scoped>

.time-keeper{
  font-size: 2rem;
}

.intro-time{
  font-size: 5rem;
  font-weight: bold;
}

</style>
